import { useState, useEffect } from "react";
import { useAuth } from "../../services/AuthContext";
import PageLayout from "../../component/PageLayout";
import IconUsers from "../../component/SvgIcon/IconUsers";
import "./style.css";

export default function UserProfile() {
    const { country } = useAuth();
    const [editing] = useState(false);
    // , setEditing
    const [form, setForm] = useState({});
    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (!storedUser) return;
        const me = JSON.parse(storedUser);
        const p = {
            userstatus: me?.status,
            fullName: me?.username,
            email: me?.email || "",
            mobile: me?.mobile || "",
            country: country || me?.country || "",
            userType: me?.userType || "",
            joined: me?.createdAt ? me.createdAt.split("T")[0] : "",
            lastLogin: new Date().toISOString().split("T")[0],
        };
        setForm(p);
    }, []);
    const initials = form.fullName
        ? form.fullName.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2)
        : "";

    const fields = [
        { label: "Full name", key: "fullName", type: "text" },
        { label: "Email", key: "email", type: "email" },
        { label: "Mobile", key: "mobile", type: "text" },
        { label: "Country", key: "country", type: "text" },
        { label: "User type", key: "userType", type: "text", readonly: true },
        { label: "Last login", key: "lastLogin", type: "text", readonly: true },
    ];

    return (

        <PageLayout icon={<IconUsers />} pagetitle="Profile Details">
            <div className="topspace">
                <div className="container-fluid">
                    <div className="profile-page-wrap">
                        <div className="profile-container">

                            <div className="profile-cover">
                                <div className="profile-cover-overlap">
                                    <div className="profile-avatar">{initials}</div>
                                    <div className="profile-cover-name">
                                        <h2>{form.fullName}</h2>
                                        <p>{form.userType} : Field Tracker</p>
                                    </div>
                                </div>
                            </div>

                            <div className="profile-body">
                                <div className="profile-top-row">
                                    <div className="profile-badges">
                                        {/* <span className="badge badge-super">{form.userType}</span> */}
                                        <span className="badge badge-active">{form.userstatus}</span>
                                    </div>
                                    {/* <button className="profile-edit-btn" onClick={() => { setEditing(!editing); setForm({ ...profile }); }}>
                                            {editing ? "Cancel" : "Edit profile"}
                                        </button> */}
                                </div>

                                <p className="profile-section-title">Personal information</p>
                                <div className="profile-fields-grid">
                                    {fields
                                        .filter(({ key }) => form[key]) // 👈 important line
                                        .map(({ label, key, type, readonly }) => (
                                            <div className="profile-field" key={key}>
                                                <label>{label}</label>
                                                {editing && !readonly ? (
                                                    <input
                                                        type={type}
                                                        value={form[key] || ""}
                                                        onChange={e => setForm({ ...form, [key]: e.target.value })}
                                                    />
                                                ) : (
                                                    <div className="profile-field-val">{form[key]}</div>
                                                )}
                                            </div>
                                        ))}
                                </div>



                                {/* <p className="profile-section-title">Account activity</p>
                                <div className="profile-stats-grid">
                                    <div className="profile-stat"><span className="stat-num">{counts.users}</span><span className="stat-lbl">Total users</span></div>
                                    <div className="profile-stat"><span className="stat-num">{counts.customers}</span><span className="stat-lbl">Customers</span></div>
                                    <div className="profile-stat"><span className="stat-num">{counts.locations}</span><span className="stat-lbl">Locations</span></div>
                                </div> */}
                                {/* 
                                    {editing && (
                                        <>
                                            <hr className="profile-divider" />
                                            <p className="profile-section-title">Change password</p>
                                            <div className="profile-fields-grid">
                                                <div className="profile-field"><label>Current password</label><input type="password" placeholder="Enter current password" /></div>
                                                <div className="profile-field"><label>New password</label><input type="password" placeholder="Enter new password" /></div>
                                                <div className="profile-field"><label>Confirm password</label><input type="password" placeholder="Confirm new password" /></div>
                                            </div>
                                            <div className="profile-save-row">
                                                <button className="profile-cancel-btn" onClick={() => setEditing(false)}>Cancel</button>
                                                <button className="profile-save-btn" onClick={handleSave}>Save changes</button>
                                            </div>
                                        </>
                                    )} */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}